import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { FabricItem } from '../../types/fabrics.types'

export type FabricProps = {
	fabric: FabricItem
	menuOptions: Option[]
}

export const Fabric = ({ fabric, menuOptions }: FabricProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{fabric.name}</p>
				<ContextMenu
					dataId={fabric.id}
					item={fabric}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: fabric.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Products')} value={fabric.products_count} />
			</dl>
		</li>
	)
}
